module.exports = __webpack_public_path__ + "static/media/forma-parte-icon.d27dba12.svg";